function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
export var Deferred = /*#__PURE__*/ function() {
    "use strict";
    function Deferred() {
        _class_call_check(this, Deferred);
        _define_property(this, "_promise", void 0);
        _define_property(this, "_resolvePromise", void 0);
        _define_property(this, "_rejectPromise", void 0);
        _define_property(this, "_isFulfilled", false);
        _define_property(this, "_isRejected", false);
        _define_property(this, "_hasAdoptedOnce", false);
        _define_property(this, "_promiseInUse", false);
        this.reset();
    }
    _create_class(Deferred, [
        {
            key: "promise",
            get: /**
   * Returns the associated promise.
   */ function get() {
                this._promiseInUse = true;
                return this._promise;
            }
        },
        {
            key: "isSettled",
            get: /**
   * Indicates if the associated promise has been either rejected or fulfilled
   */ function get() {
                return this._isFulfilled || this._isRejected;
            }
        },
        {
            key: "isFulfilled",
            get: /**
   * Indicates if the associated promise has been fulfilled.
   */ function get() {
                return this._isFulfilled;
            }
        },
        {
            key: "isRejected",
            get: /**
   * Indicates if the associate promise has been rejected.
   */ function get() {
                return this._isRejected;
            }
        },
        {
            /**
   * Adopts a promise to drive this Deferred's lifecyle. That is, when the passed-in promise is resolved, this
   * deferred's promise will also be resolved. Same for rejection.
   * @param promise - The promise to adopt.
   * @returns - This deferred's promise. (Not the adopted promise! Although, they have the effectively the same
   *      lifecycle now.)
   */ key: "adopt",
            value: function adopt(promise) {
                this._promiseInUse = true;
                promise.then(this._resolvePromise).catch(this._rejectPromise);
                return this.promise;
            }
        },
        {
            /**
   * Adopts a promise to drive this Deferred's lifecycle, similar to `adopt`. The adopted promise is created by
   * running the provided `promiseFactory` method. If `adoptOnce` is called multiple times, only the `promiseFactory`
   * from the first call will be run, and only that promise will be adopted.
   * @param promiseFactory - A function that returns a promise when executed. This Deferred adoptes the returned
   *      promise.
   * @returns - This deferred's promise. (Not the adopted promise! Although, they have the effectively the same
   *      lifecycle now.)
   */ key: "adoptOnce",
            value: function adoptOnce(promiseFactory) {
                this._promiseInUse = true;
                if (this._hasAdoptedOnce) {
                    return this.promise;
                }
                this.adopt(promiseFactory());
                this._hasAdoptedOnce = true;
                return this.promise;
            }
        },
        {
            /**
   * Fulfills the associated promise with the specified value.
   *
   * @param value - used to execute the resolve method of the associated promise with the value specified
   */ key: "resolve",
            value: function resolve(value) {
                this._resolvePromise(value);
            }
        },
        {
            /**
   * Rejects the associated promise with the given error.
   *
   * @param reason - reason for the rejection
   */ key: "reject",
            value: function reject(reason) {
                this._rejectPromise(reason);
            }
        },
        {
            /**
   * Creates and configures new promise. If the current promise is in use and not yet fulfilled it will be rejected.
   */ key: "reset",
            value: function reset() {
                var _this = this;
                if (!this._isFulfilled && !this._isRejected && this._promiseInUse && this._rejectPromise) {
                    this._rejectPromise(new Error('DeferredPromiseReset: "Deferred was reset before result arrived"'));
                }
                this._isFulfilled = false;
                this._isRejected = false;
                this._hasAdoptedOnce = false;
                this._promiseInUse = false;
                this._promise = new Promise(function(resolve, reject) {
                    _this._resolvePromise = function(value) {
                        _this._isFulfilled = true;
                        _this._isRejected = false;
                        resolve(value);
                    };
                    _this._rejectPromise = function(reason) {
                        _this._isRejected = true;
                        _this._isFulfilled = false;
                        reject(reason);
                    };
                });
            }
        }
    ]);
    return Deferred;
}();

//# sourceMappingURL=Deferred.js.map